import React from "react";
import MenuList from "./_/components/menu";
import "./style.scss";

const CustomMenu = props => <MenuList {...props} />;

export default CustomMenu;
